import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import AttachmentUploader, { FILE_TYPE } from '@src/js/common/ark-extensions/dc-components/attachment-uploader';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { Feature } from '@tencent/workbench';
import { config, FROM_LOCAL, FROM_TENCENT_DOCS } from './config';

interface IOnClickProps {
    name: string;
    clickFrom?: string;
}

@Feature()
export class InsertVideoFeature extends BaseToolbarFeature {
    public id = config.id;
    public config = config;
    private clickOper = {
        [FROM_LOCAL.id]: this.onClickFromLocal,
        [FROM_TENCENT_DOCS.id]: this.onClickFromTencentDocs,
    };

    public constructor() {
        super();
    }

    public insertVideo(name: string, clickFrom?: string) {
        this.clickOper[name].bind(this)({ name, clickFrom });
    }

    private async onClickFromLocal({ name, clickFrom }: IOnClickProps) {
        AttachmentUploader.getInstance().upload({ acceptFileType: { video: FILE_TYPE.video } });
        try {
            this.twdReport(name, clickFrom);
        } catch (e) {
            console.log('upload video twd error');
        }
    }

    private onClickFromTencentDocs({ name, clickFrom }: IOnClickProps) {
        this.getDriveSelectorPanelService()?.then((DriveSelectorPanelService) => {
            DriveSelectorPanelService?.show({
                serviceList: ['attachmentManager'],
                config: {
                    target: 'video',
                },
            });
        });

        try {
            this.twdReport(name, clickFrom);
        } catch (e) {
            window.log.error('upload video twd error');
        }
    }

    private getDriveSelectorPanelService() {
        return (
            AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices
        ).editableServiceLayer?.driveSelectorPanelService.promise();
    }
}
